import { AdminPickSummary, AdminUserResponse, User } from "../../models/AdminModels";
import { FormControl, InputLabel, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";

import "./AdminImpersonate.scss";

export const AdminInfo = () => {
  const [emails, setEmails] = useState<string>("");
  
  useEffect(() => {
    //TODO:DF Local loading indicator
    axios.get<{picks: AdminPickSummary[]}>(`${process.env.REACT_APP_API_URL}/admin/yearStatus`).then((r) => {
      
      setEmails(r.data.picks.filter(p => (p.round1PickCount || 0) > 0).map(u => u.username).join("; "));
    });
  }, []);
  
  return (
    <div className="admin-impersonate">
      <div className="command-list">
        <FormControl sx={{ m: 1, minWidth: 220 }} size="small">
          <InputLabel>Information</InputLabel>
          <TextField
          fullWidth={true}
          multiline={true}
          rows={100}
            value={emails}
            label="Registered Emails"
          />
        </FormControl>
      </div>
    </div>
  );
};



